const statesRegistry = new Map();

const StateFactory = ({ container }) =>
  (name, defaultState, type = 'session') => {
    if (statesRegistry.has(name)) {
      return statesRegistry.get(name);
    }

    const state = container.get('StateInstance');
    state.init(name, defaultState, type);
    statesRegistry.set(name, state);

    return state;
  };

export default StateFactory;



// WEBPACK FOOTER //
// ./src/services/StateFactory.js